import React, { Component } from "react";
import "./Loading.css";
class Loading extends Component {
  render() {
    return (
      <div className="image-loading">
        <img src={require("./../../assets/images/logoloading.gif")} alt="" />
      </div>
    );
  }
}

export default Loading;
